import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  TrackByFunction
} from '@angular/core'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { Subject, Subscription } from 'rxjs'
import { takeUntil } from 'rxjs/operators'
import { ResultSet, Result, ResultWidget, SortDropdown } from '../../results/interfaces/result.interfaces'

@Component({
  selector: 'flo-result-widget',
  templateUrl: './result-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResultWidgetComponent implements OnDestroy {
  @Input() results: ResultWidget
  @Output()
  readonly sortChange = new EventEmitter<SortDropdown>()
  private readonly ngOnDestroy$ = new Subject<void>()

  // need to support on changes for this
  public filterForm = new UntypedFormGroup({
    sort: new UntypedFormControl()
  })

  setResultByFormInput: Subscription = this.filterForm.valueChanges
    .pipe(takeUntil(this.ngOnDestroy$))
    .subscribe(sort => {
      this.sortChange.next(sort)
    })

  trackByResultContent: TrackByFunction<ResultSet> = (index: number, item: any) => {
    return item.id
  }

  trackByResultData: TrackByFunction<Result> = (index: number, item: any) => {
    return item.id
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next()
    this.ngOnDestroy$.complete()
  }
}
